import { Component, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { environment } from '../core/environment';

@Component({
  selector: 'app-qr',
  standalone: true,
  imports: [ReactiveFormsModule],
  template: `
    <div class="page-header">
      <div>
        <h2>QR Card Generator</h2>
        <p>Create student, staff, and temporary guest membership cards.</p>
      </div>
    </div>

    <section class="split-grid">
      <form class="panel form-panel" [formGroup]="form" (ngSubmit)="generate()">
        <h3>Generate Card</h3>
        <label>Person Type
          <select formControlName="personType">
            <option>Student</option>
            <option>Staff</option>
            <option>Guest</option>
          </select>
        </label>
        <label>Person Id <input formControlName="personId"></label>
        <button class="primary-action" type="submit" [disabled]="form.invalid">Generate</button>
      </form>

      @if (card()) {
        <article class="member-card">
          <span>Membership Card</span>
          <strong>{{ card()?.cardNumber }}</strong>
          <code>{{ card()?.qrPayload }}</code>
        </article>
      }
    </section>
  `
})
export class QrComponent {
  private readonly http = inject(HttpClient);
  private readonly fb = inject(FormBuilder);
  readonly card = signal<{ cardNumber: string; qrPayload: string } | null>(null);
  readonly form = this.fb.nonNullable.group({
    personType: ['Student', Validators.required],
    personId: ['', Validators.required]
  });

  generate(): void {
    const value = this.form.getRawValue();
    this.http.post<{ cardNumber: string; qrPayload: string }>(`${environment.apiUrl}/qr/cards/${value.personType}/${value.personId}`, {}).subscribe((card) => this.card.set(card));
  }
}
